import apiRoutes from "../../Routes/Routes.json";
import HttpClient from "HttpClient";

export const GetAll = (queryModel: any) => {
  return HttpClient().post(`/${apiRoutes.Oncology.GetAll}`, queryModel);
};

export const CreateBatch = (queryModel: any) => {
  return HttpClient().post(`/${apiRoutes.Oncology.CreateBatch}`, queryModel);
};

export const GetAllBatches = (queryModel: any) => {
  return HttpClient().post(`${apiRoutes.Oncology.GetAllBatchs}`, queryModel);
};

export const PostBatchStepDetails = (payload: any) => {
  return HttpClient().post(
    `${apiRoutes.Oncology.PostBatchStepDetails}`,
    payload
  );
};

export const GetBatchStepDetailById = (batchId: number, stepNumber: number) => {
  return HttpClient().get(
    `${apiRoutes.Oncology.GetBatchStepDetails}?batchId=${batchId}&stepNumber=${stepNumber}`
  );
};

export const GetBatchStepLogsAsync = (batchId: number) => {
  return HttpClient().get(
    apiRoutes.Oncology.GetBatchStepLogs.replace("{batchId}", String(batchId))
  );
};

export type OncologyBatchExportQueryModel = {
  batchName?: string | null;
  batchCode?: string | null;
  runDate?: string | null;
  plateBarcodeNo?: string | null;
  stepNumber?: string | null;
  batchStatus?: string | null;
};

export type ExportBatchesExcelPayload = {
  selectedIds: number[];
  queryModel?: OncologyBatchExportQueryModel;
};

export const ExportBatchesExcel = (payload: ExportBatchesExcelPayload) => {
  return HttpClient().post(apiRoutes.Oncology.ExportBatchesExcel, payload);
};

export const UploadQuantificationFile = (
  batchId: number,
  stepNumber: number,
  file: File
) => {
  const formData = new FormData();
  formData.append("BatchId", batchId.toString());
  formData.append("StepNumber", stepNumber.toString());
  formData.append("File", file);

  return HttpClient().post(
    `${apiRoutes.Oncology.UploadQuantificationFile}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};
